module.exports = __webpack_public_path__ + "images/file_icons_v2/msg-09e2d4c243c1d5afb260eb4138101818.svg";